  <template>
    <div v-if="loading">Loading...</div>
    <div v-else>
      <component
        v-for="(block) in blocks"
        :key="block.id"
        :is="getComponent(block.BlockID)"
        v-bind="block"
        :block="block"
      />
    </div>
  </template>
  
  <script>
  import { defineAsyncComponent } from 'vue';
  import axios from "axios";
  const IntroLetter = defineAsyncComponent(() =>
    import('@/components/FortBuilder/IntroLetter.vue')
  );
  const ScoreCard = defineAsyncComponent(() =>
    import('@/components/FortBuilder/ScoreCard.vue')
  );
  const DeliverWin = defineAsyncComponent(() =>
    import('@/components/FortBuilder/DeliverWin.vue')
  );
  const AbovePar = defineAsyncComponent(() =>
    import('@/components/FortBuilder/AbovePar.vue')
  );
  const VmUpdate = defineAsyncComponent(() =>
    import('@/components/FortBuilder/VmUpdate.vue')
  );
  const NewsToKnow = defineAsyncComponent(() =>
    import('@/components/FortBuilder/NewsToKnow.vue')
  );
  const SaveTheDate = defineAsyncComponent(() =>
    import('@/components/FortBuilder/SaveTheDate.vue')
  );
  // Optional: Include Divider if it needs a BlockID
  // const Divider = defineAsyncComponent(() =>
  //   import('@/components/FortBuilder/Divider.vue')
  // );
  
  export default {
    name: 'FortBuilder',
    props: {
      blocks: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
      }
    },
    methods:{
      getComponent(blockId) {
        // Map BlockIDs to components
        const components = {
          1: IntroLetter,
          2: ScoreCard,
          3: DeliverWin,
          4: AbovePar,
          5: VmUpdate,
          6: NewsToKnow,
          7: SaveTheDate,
        };
        // Return the component for the blockId, fallback to IntroLetter
        return components[blockId] || components[1];
      },
    },
    mounted() {
        // this.loadContent();
        // console.log("ran");
    },
      
    computed: {
   
      /*
      pageComponent() {
        // Map BlockIDs to components
        const components = {
          1: IntroLetter,
          2: ScoreCard,
          3: DeliverWin,
          4: AbovePar,
          5: VmUpdate,
          6: NewsToKnow,
          7: SaveTheDate,
          // Optional: Add Divider if needed
          // divider: Divider,
        };
        // Return the component for the blockId, fallback to BlockID 1
        return components[this.blockId] || components[1];
        // return components[this.blockId];
      },
      */
    
    },
  };
  </script>